export default __webpack_public_path__ + "static/media/pig_grayscale.d03ab651.svg";